// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"19646330","374":"65315b52","481":"81ca460d","562":"7c1f1c0b","582":"ad4f655e","659":"517c9e43"}[chunkId] + ".chunk.js";
};